<div class='row mtlg maxWidthWrapper mt-5' role='alert' *ngIf="isSearchFeedbackEnabled">
    <div id='feedback'>
        <p style='text-align:center'>Was this page helpful?<br />
            <button type="button" class='btn btn-primary btn-sm mx-1' (click)="feedback_thanks('helpful')">Yes</button>
            <button type="button" class='btn btn-warning btn-sm mx-1'  id="nothelpful" (click)="feedback_thanks('not_helpful')">No</button></p>
        <div class="m-auto p-1 alert alert-success w-50 align-content-center" style="text-align: center;" *ngIf="feedbackFormStatus=='submitted'">
            <p class="m-1 p-1">Thank you for your feedback !</p>
        </div>
        <div class="m-auto p-1 alert alert-warning w-50 align-content-center" style="text-align: center;" *ngIf="feedbackFormStatus=='failed'">
            <p class="m-1 p-1">There was a problem submitting your request. Please try again later.</p>
        </div>
    </div>
</div>
<ng-template #content let-modal>
    <form [formGroup]="feedbackForm" (ngSubmit)="submit_feedback()">
        <div class="modal-header">
            <p class="m-0 h4">What could make this page better?</p>
        </div>
        <div class="modal-body">
            <textarea id="feedback_text" name="feedback_text" class='form-control' rows="4" formControlName="feedback"></textarea><br />
            <p class="small">Thank you for helping us make PAWS better. Your comment will be forwarded to our support team.</p>
            <div class="m-1 p-1" style="text-align: center;" *ngIf="feedbackFormStatus=='sending'">
                <p class="h4 text-muted">Submitting Feedback.</p>
                <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                <p class="h5 text-muted">Please wait</p>
            </div>
            <div class="m-1 p-1 alert alert-success" style="text-align: center;" *ngIf="feedbackFormStatus=='success'">
                <p class="m-1 p-1">Thank you for your feedback !</p>
            </div>
            <div class="m-1 p-1 alert alert-warning" style="text-align: center;" *ngIf="feedbackFormStatus=='modalFailed'">
                <p class="m-1 p-1">There was a problem submitting your request. Please try again later.</p>
            </div>
        </div>
        <div class="modal-footer">
            <button type="submit" class="btn btn-primary">Send feedback</button>
            <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Cross click')">Dismiss</button>
        </div>
    </form>
</ng-template>
